import { useEffect } from 'react';
import { getLocaleStore } from '@/i18n';
import type { IFramework } from '../../framework';

/** 重做 / 撤销 */
export function useRedoUndoHotkey(framework: IFramework) {
    useEffect(() => {
        const { $t } = getLocaleStore();
        framework.service.hotkey.register({
            name: $t((v) => v.Text_Redo),
            win: 'Shift Ctrl Z',
            mac: '⇧ ⌘ Z',
            key: 'redo',
            processors: [
                {
                    press: ['Shift+Ctrl+Z', 'Shift+Command+Z', 'Ctrl+y', 'Command+y'],
                    fn: () => {
                        framework.service.history.redo();
                    },
                },
            ],
        });
        framework.service.hotkey.register({
            name: $t((v) => v.Text_Undo),
            win: 'Ctrl Z',
            mac: '⌘ Z',
            key: 'undo',
            processors: [
                {
                    press: ['Ctrl+Z', 'Command+Z'],
                    fn: () => {
                        framework.service.history.undo();
                    },
                },
            ],
        });
    }, []);
}
